// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__EsWx1","active":"Modal_active__zUgSG","modalContent":"Modal_modalContent__3ls9q","close":"Modal_close__RGDsJ"};